import React from 'react';
import { motion } from 'framer-motion';
interface PricingProps {
  selectedPlan: 'pro' | 'megapack';
  onSelectPlan: (plan: 'pro' | 'megapack') => void;
}
export function Pricing({
  selectedPlan,
  onSelectPlan
}: PricingProps) {
  const plans = [{
    id: 'pro',
    name: 'Kit Pro',
    desc: '6 tomos + 3 bonos',
    oldPrice: '$27.990',
    price: '$19.990',
    url: 'https://checkout.solucionesya.shop/cart/48864550977784:1'
  }, {
    id: 'megapack',
    name: 'Megapack Pro',
    desc: '8 tomos + 3 bonos',
    oldPrice: '$35.990',
    price: '$29.990',
    badge: '⭐ Más elegida',
    url: 'https://checkout.solucionesya.shop/cart/48864554877176:1'
  }];
  const currentPlan = plans.find(p => p.id === selectedPlan) || plans[1];
  return <section id="pricing" className="bg-cream py-10 sm:py-20 px-5" data-id="element-193">
      <div className="max-w-6xl mx-auto" data-id="element-194">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-195">
          Elegí tu kit
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-8 sm:mb-10 leading-tight" data-id="element-196">
          Seleccioná tu opción
        </h2>

        <div className="max-w-2xl mx-auto bg-white rounded-2xl p-5 sm:p-8 shadow-xl border border-gray-100" data-id="element-197">
          <div className="flex flex-col gap-3 sm:gap-4 mb-6" data-id="element-198">
            {plans.map(plan => {
            const isSelected = selectedPlan === plan.id;
            return <div key={plan.id} onClick={() => onSelectPlan(plan.id as 'pro' | 'megapack')} className={`flex items-center justify-between p-4 sm:p-5 rounded-xl border-2 cursor-pointer transition-all ${isSelected ? 'border-gold bg-gold/5 shadow-sm' : 'border-gray-100 hover:border-gray-300 bg-white'}`} data-id="element-199">
                  <div className="flex items-center gap-3 sm:gap-4" data-id="element-200">
                    <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isSelected ? 'border-gold' : 'border-gray-300'}`} data-id="element-201">
                      {isSelected && <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-gold rounded-full" data-id="element-202" />}
                    </div>
                    <div className="text-left" data-id="element-203">
                      <div className="font-bold text-navy text-sm sm:text-lg flex items-center flex-wrap gap-2" data-id="element-204">
                        {plan.name}
                        {plan.badge && <span className="text-[9px] sm:text-[10px] bg-gold text-navy px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-205">
                            {plan.badge}
                          </span>}
                      </div>
                      <div className="text-[11px] sm:text-sm text-gray mt-0.5" data-id="element-206">
                        {plan.desc}
                      </div>
                    </div>
                  </div>
                  <div className="text-right pl-2" data-id="element-207">
                    <div className="text-[10px] sm:text-xs text-gray line-through mb-0.5" data-id="element-208">
                      {plan.oldPrice}
                    </div>
                    <div className="font-display font-bold text-lg sm:text-2xl text-navy leading-none" data-id="element-209">
                      {plan.price}
                    </div>
                  </div>
                </div>;
          })}
          </div>

          <div className="bg-[#fafafa] rounded-xl p-4 sm:p-5 mb-6 border border-gray-100" data-id="element-210">
            <h4 className="font-bold text-navy text-xs sm:text-sm mb-3" data-id="element-211">
              ¿Qué incluye tu selección?
            </h4>
            <ul className="space-y-2" data-id="element-212">
              <li className="text-[11px] sm:text-sm text-gray-800 pl-6 relative" data-id="element-213">
                <span className="absolute left-0 text-green-light font-bold" data-id="element-214">
                  ✓
                </span>{' '}
                6 tomos principales (10 págs. c/u)
              </li>
              <li className="text-[11px] sm:text-sm text-gray-800 pl-6 relative" data-id="element-215">
                <span className="absolute left-0 text-green-light font-bold" data-id="element-216">
                  ✓
                </span>{' '}
                3 bonos de alto valor clínico
              </li>
              <li className="text-[11px] sm:text-sm text-gray-800 pl-6 relative" data-id="element-217">
                <span className="absolute left-0 text-green-light font-bold" data-id="element-218">
                  ✓
                </span>{' '}
                Plantillas y checklists editables
              </li>
              {selectedPlan === 'megapack' && <>
                  <li className="text-[11px] sm:text-sm text-navy font-semibold pl-6 relative mt-3" data-id="element-219">
                    <span className="absolute left-0 text-gold font-bold" data-id="element-220">
                      ✓
                    </span>{' '}
                    T7 — Cómo hablar de plata sin conflicto
                  </li>
                  <li className="text-[11px] sm:text-sm text-navy font-semibold pl-6 relative" data-id="element-221">
                    <span className="absolute left-0 text-gold font-bold" data-id="element-222">
                      ✓
                    </span>{' '}
                    T8 — El propietario emocionalmente desbordado
                  </li>
                  <li className="text-[11px] sm:text-sm text-navy font-semibold pl-6 relative" data-id="element-223">
                    <span className="absolute left-0 text-gold font-bold" data-id="element-224">
                      ✓
                    </span>{' '}
                    Plantilla de presupuesto profesional
                  </li>
                </>}
            </ul>
          </div>

          <motion.a href={currentPlan.url} whileHover={{
          y: -2,
          boxShadow: '0 10px 32px rgba(201,149,42,0.45)'
        }} whileTap={{
          scale: 0.96
        }} className="block w-full text-center bg-gradient-to-br from-gold to-gold-light text-navy font-bold text-sm sm:text-lg py-4 rounded-xl shadow-[0_6px_24px_rgba(201,149,42,0.35)] transition-all" data-id="element-225">
            💥 COMPRAR {currentPlan.name.toUpperCase()} · {currentPlan.price}
          </motion.a>

          <div className="text-center mt-4" data-id="element-226">
            <span className="inline-block bg-[#e8f7f0] text-green text-[10px] sm:text-xs font-semibold px-3 py-1 rounded-full" data-id="element-227">
              Ahorrás $8.000 con esta oferta
            </span>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-[11px] sm:text-sm text-gray mt-8" data-id="element-228">
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-229">
            <span className="text-green text-sm sm:text-lg" data-id="element-230">✓</span> Pago seguro
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-231">
            <span className="text-green text-sm sm:text-lg" data-id="element-232">✓</span> Acceso en 5
            min
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-233">
            <span className="text-green text-sm sm:text-lg" data-id="element-234">✓</span> Garantía 7
            días
          </div>
        </div>
      </div>
    </section>;
}